import * as Types from '../types';

interface Action<P = undefined> {
  type: string;
  payload?: P;
}

export function clientInvitesSync(invites: unknown): Action<{ invites: unknown }> {
  const action = {
    type: Types.CLIENT_INVITES_SYNC,
    payload: {
      invites,
    },
  };
  return action;
}

export function acceptInvite(
  userId: string,
  inviteId: string,
): Action<{ userId: string; inviteId: string }> {
  const action = {
    type: Types.ACCEPT_INVITE,
    payload: {
      userId,
      inviteId,
    },
  };
  return action;
}

export function dismissInvite(
  inviteToken: string,
  inviteId: string,
): Action<{ inviteToken: string; inviteId: string }> {
  const action = {
    type: Types.DISMISS_INVITE,
    payload: {
      inviteToken,
      inviteId,
    },
  };

  return action;
}

export function dismissInviteSuccess(inviteToken: string): Action<{ inviteToken: string }> {
  const action = {
    type: Types.DISMISS_INVITE_SUCCESS,
    payload: {
      inviteToken,
    },
  };

  return action;
}

export function clientAcceptInviteResult(
  open: boolean,
  success: boolean,
  result: unknown,
): Action<{ open: boolean; success: boolean; result: unknown }> {
  const action = {
    type: Types.CLIENT_ACCEPT_INVITE_RESULT,
    payload: {
      open,
      success,
      result,
    },
  };
  return action;
}

export function clientAcceptInviteResultClear(): Action {
  const action = {
    type: Types.CLIENT_ACCEPT_INVITE_RESULT_CLEAR,
  };
  return action;
}
